<script setup lang="ts" generic="T">
const {
    items,
    threshold = 1,
    hasNext,
} = defineProps<{
    items: T[];
    hasNext?: boolean;
    threshold?: number;
}>();

const emit = defineEmits<{
    load: [];
}>();

const wrapper = ref<HTMLDivElement>();
useMrInfiniteScroll({
    hasNext,
    wrapper,
    itemsLength: computed(() => items.length),
    threshold,
    onLoad: () => emit('load'),
});
</script>

<template>
    <div ref="wrapper">
        <div v-for="(item, index) in items" :key="index">
            <slot name="item" :item :index />
        </div>
    </div>
</template>
